import { Component, OnInit } from '@angular/core';
import { ServiceService } from '../../service.service';

interface KpiParameter {
  no: number;
  parameter: string;
  isComingSoon: boolean;
  isSelected: boolean;
  hasTarget: boolean;
  lastMonthValue: number | null;
  target: number | null;
  managerProposedMark: number | null;
  score: number | null;
}

interface Employee {
  employee_id: string;
  employee_name: string;
}

interface ReportRow {
  no: number;
  parameter: string;
  target: number | string;
  achieved: number | string;
  managersScore: number | string;
  score: number | string;
}

@Component({
  selector: 'app-kpi-monthly-reports',
  templateUrl: './kpi-monthly-reports.component.html',
  styleUrls: ['./kpi-monthly-reports.component.css']
})
export class KpiMonthlyReportsComponent implements OnInit {

  activeTabIndex: number = 0;
  isAdmin: boolean = false;
  loggedInEmployeeId: string = '';
  loadingEmployees: boolean = false;
  isSubmitting: boolean = false;
  loadingKpiData: boolean = false;

  employeeDropdown: Employee[] = [];

  // Form Tab
  selectedFormEmployee: Employee | null = null;
  currentMonth: string = '';
  currentMonthLabel: string = '';
  kpiManagerId: string = '';

  // Report Tab
  selectedReportEmployee: Employee | null = null;
  selectedReportMonth: string = '';
  reportData: ReportRow[] = [];
  incentiveDeduction: number = 0;
  showReport: boolean = false;
  loadingReport: boolean = false;

  kpiParameters: KpiParameter[] = [
    { no: 1, parameter: 'Sales Target', isComingSoon: false, isSelected: false, hasTarget: false, lastMonthValue: null, target: null, managerProposedMark: null, score: null },
    { no: 2, parameter: 'Receipt Target', isComingSoon: false, isSelected: false, hasTarget: false, lastMonthValue: null, target: null, managerProposedMark: null, score: null },
    { no: 3, parameter: 'Brand Target (Shaji)', isComingSoon: false, isSelected: false, hasTarget: false, lastMonthValue: null, target: null, managerProposedMark: null, score: null },
    { no: 4, parameter: 'Brand Target (Zeal)', isComingSoon: false, isSelected: false, hasTarget: false, lastMonthValue: null, target: null, managerProposedMark: null, score: null },
    { no: 5, parameter: 'Brand Target (Cromax)', isComingSoon: false, isSelected: false, hasTarget: false, lastMonthValue: null, target: null, managerProposedMark: null, score: null },
    { no: 6, parameter: 'Active Qualified > 70%', isComingSoon: false, isSelected: false, hasTarget: true, lastMonthValue: null, target: 70, managerProposedMark: null, score: null }, { no: 7, parameter: 'Active Qualified Target', isComingSoon: false, isSelected: false, hasTarget: true, lastMonthValue: null, target: null, managerProposedMark: null, score: null },
    { no: 8, parameter: 'Non Qualified to Qualified Target', isComingSoon: false, isSelected: false, hasTarget: true, lastMonthValue: null, target: null, managerProposedMark: null, score: null },
    { no: 9, parameter: 'Overdue Inactive', isComingSoon: false, isSelected: false, hasTarget: true, lastMonthValue: null, target: 5, managerProposedMark: null, score: null }, { no: 10, parameter: 'Total Overdue customer no', isComingSoon: false, isSelected: false, hasTarget: true, lastMonthValue: null, target: null, managerProposedMark: null, score: null },
    { no: 11, parameter: 'Active Leads', isComingSoon: false, isSelected: false, hasTarget: true, lastMonthValue: null, target: null, managerProposedMark: null, score: null },
    { no: 12, parameter: 'Lost Active Qualified', isComingSoon: true, isSelected: false, hasTarget: true, lastMonthValue: null, target: null, managerProposedMark: null, score: null },
    { no: 13, parameter: 'Atleast 1 Sales from 4 Projection done', isComingSoon: true, isSelected: false, hasTarget: true, lastMonthValue: null, target: null, managerProposedMark: null, score: null },
    { no: 14, parameter: 'Lead conversion', isComingSoon: true, isSelected: false, hasTarget: true, lastMonthValue: null, target: null, managerProposedMark: null, score: null },
    { no: 15, parameter: 'Process KPI', isComingSoon: true, isSelected: false, hasTarget: true, lastMonthValue: null, target: null, managerProposedMark: null, score: null },
    { no: 16, parameter: 'Bonus KPI (Special product sales/trainings etc)', isComingSoon: true, isSelected: false, hasTarget: true, lastMonthValue: null, target: null, managerProposedMark: null, score: null },
    { no: 17, parameter: 'Share KPI (Min and max 20 mark per month)', isComingSoon: true, isSelected: false, hasTarget: true, lastMonthValue: null, target: null, managerProposedMark: null, score: null },
  ];

  constructor(private employeeService: ServiceService) { }

  ngOnInit(): void {
    this.setCurrentMonth();
    this.loadEmployees();
  }

  setCurrentMonth(): void {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    this.currentMonth = `${year}-${month}`;
    this.currentMonthLabel = today.toLocaleString('default', { month: 'long', year: 'numeric' });
  }

  loadEmployees(): void {
    this.loadingEmployees = true;
    const department = localStorage.getItem('department');
    this.loggedInEmployeeId = localStorage.getItem('admin_id') || '';
    this.isAdmin = department === 'TRAINING CENTRE DEPT.';

    if (this.isAdmin) {
      this.employeeService.ViewAllEmployee().subscribe({
        next: (res: any) => {
          this.employeeDropdown = res.data || [];
          this.loadingEmployees = false;
        },
        error: (err: any) => {
          console.error('Error loading employees:', err);
          this.loadingEmployees = false;
        }
      });
    } else {
      this.employeeService.getManagerTeamMembers(this.loggedInEmployeeId).subscribe({
        next: (res: any) => {
          this.employeeDropdown = res.data || [];
          this.loadingEmployees = false;
        },
        error: (err: any) => {
          console.error('Error loading team members:', err);
          this.loadingEmployees = false;
        }
      });
    }
  }

  // ── Tab 1: Form ─────────────────────────────────────────────────────────────

  onFormEmployeeChange(): void {
    this.kpiManagerId = '';
    this.resetKpiRows();
    if (!this.selectedFormEmployee) return;
    this.loadKpiData();
  }

  loadKpiData(): void {
    if (!this.selectedFormEmployee) return;

    this.loadingKpiData = true;
    const empId = this.selectedFormEmployee.employee_id;

    this.employeeService.getKpiReport(empId, this.currentMonth).subscribe({
      next: (res: any) => {
        this.loadingKpiData = false;

        // Handle the API response format
        if (res.success && Array.isArray(res.data)) {
          console.log('KPI Form API response:', res);
          this.populateFormFromApiData(res.data);
        }
      },
      error: (err: any) => {
        this.loadingKpiData = false;
        console.log('No existing KPI data:', err?.error?.message || err);
      }
    });
  }

  private populateFormFromApiData(dataArray: any[]): void {
    if (!dataArray || dataArray.length === 0) {
      console.log('No data to populate form');
      return;
    }

    const parameterToRowMap: { [key: string]: number } = {
      'Sales Target': 1,
      'Receipt Target': 2,
      'Brand Target (Shaji)': 3,
      'Brand Target (Zeal)': 4,
      'Brand Target (Cromax)': 5,
      'Active Qualified  > 70%': 6,
      'Active Qualified Target': 7,
      'Non Qualified to Qualified Target': 8,
      'Overdue Inactive': 9,
      'Total Overdue customer no': 10,
      'Active Leads': 11
    };

    dataArray.forEach(item => {
      const rowNo = parameterToRowMap[item.parameter];
      if (rowNo) {
        const param = this.kpiParameters.find(p => p.no === rowNo);
        if (param) {
          param.isSelected = false;

          // AFTER
          if (param.no === 6 || param.no === 9) {
            param.managerProposedMark = item.manager_score ?? null;
            param.lastMonthValue = item.last_month_value ?? null;
          } else if (param.no >= 1 && param.no <= 5) {   // ← manager score only
            param.managerProposedMark = item.manager_score ?? null;
          } else {
            param.target = item.target ?? null;
            param.managerProposedMark = item.manager_score ?? null;
            param.lastMonthValue = item.last_month_value ?? null;
            param.score = item.score ?? null;
          }
        }
      }
    });
  }

  isFormValid(): boolean {
    if (!this.selectedFormEmployee) return false;
    return this.kpiParameters.some(p => p.isSelected && !p.isComingSoon);
  }

  onCheckboxChange(param: KpiParameter): void {
    if (param.isComingSoon) return;
    param.isSelected = !param.isSelected;
  }

  onTargetInput(param: KpiParameter, event: Event): void {
    const val = (event.target as HTMLInputElement).value;
    param.target = val === '' ? null : Number(val);
  }

  onManagerMarkInput(param: KpiParameter, event: Event): void {
    const input = event.target as HTMLInputElement;
    const val = input.value;
    if (val === '') {
      param.managerProposedMark = null;
      return;
    }
    const num = Math.abs(Number(val));
    param.managerProposedMark = -num;
    input.value = String(-num);
  }

  submitForm(): void {
    if (!this.selectedFormEmployee) {
      this.employeeService.showToast('error', 'Please select an employee');
      return;
    }

    const selected = this.kpiParameters.filter(p => p.isSelected && !p.isComingSoon);
    if (selected.length === 0) {
      this.employeeService.showToast('error', 'Please select at least one KPI parameter');
      return;
    }

    const loggedInId = localStorage.getItem('admin_id') || '';
    const createdBy = loggedInId;

    const body: any = {
      employee_id: this.selectedFormEmployee.employee_id,
      month: this.currentMonth,
      created_by: createdBy,
    };

    selected.forEach(param => {
      switch (param.no) {
        case 1:
          body['sales_target_selected'] = true;
          body['agreed_sales_manager_score'] = param.managerProposedMark ?? 0;
          break;

        case 2:
          body['receipt_target_selected'] = true;
          body['agreed_receipts_manager_score'] = param.managerProposedMark ?? 0;
          break;

        case 3:
          body['brand_target_shaji_selected'] = true;
          body['brand_target_shaji_manager_score'] = param.managerProposedMark ?? 0;
          break;

        case 4:
          body['brand_target_zeal_manager_score'] = param.managerProposedMark ?? 0;
          break;

        case 5:
          body['brand_target_cromax_manager_score'] = param.managerProposedMark ?? 0;
          break;

        case 6:
          body['active_qualified_high_target'] = 70;
          body['active_qualified_high_manager_score'] = param.managerProposedMark ?? 0;
          body['active_qualified_high_acheived'] = param.lastMonthValue ?? 0;
          break;

        case 7:
          body['active_qualified_count'] = param.target ?? 0;
          body['active_qualified_manager_score'] = param.managerProposedMark ?? 0;
          body['active_qualified_acheived'] = param.lastMonthValue ?? 0;
          break;

        case 8:
          body['non_qualified_to_qualified_count'] = param.target ?? 0;
          body['non_qualified_to_qualified_manager_score'] = param.managerProposedMark ?? 0;
          body['non_qualified_to_qualified_acheived'] = param.lastMonthValue ?? 0;
          break;

        case 9:
          body['overdue_inactive_target'] = 5;
          body['overdue_inactive_manager_score'] = param.managerProposedMark ?? 0;
          body['overdue_inactive_acheived'] = param.lastMonthValue ?? 0;
          break;

        case 10:
          body['total_overdue_customer_target'] = param.target ?? 0;
          body['total_overdue_customer_manager_score'] = param.managerProposedMark ?? 0;
          body['total_overdue_customer_count'] = param.lastMonthValue ?? 0;
          break;

        case 11:
          body['active_leads_count'] = param.target ?? 0;
          body['active_leads_manager_score'] = param.managerProposedMark ?? 0;
          body['active_leads_acheived'] = param.lastMonthValue ?? 0;
          break;
      }
    });

    this.isSubmitting = true;

    this.employeeService.kpiAssignTarget(body).subscribe({
      next: (res: any) => {
        this.isSubmitting = false;
        if (res.success) {
          this.employeeService.showToast('success', 'KPI targets assigned successfully');
          this.resetForm();
        } else {
          this.employeeService.showToast('error', res.message || 'Failed to assign targets');
        }
      },
      error: (err: any) => {
        this.isSubmitting = false;
        const msg = err?.error?.message || 'API error occurred';
        this.employeeService.showToast('error', msg);
      }
    });
  }

  private resetKpiRows(): void {
    this.kpiParameters.forEach(p => {
      p.isSelected = false;
      p.managerProposedMark = null;
      p.score = null;
      p.lastMonthValue = null;
      // Keep fixed targets for rows 6 and 9
      if (p.no !== 6 && p.no !== 9) {
        p.target = null;
      }
    });
  }

  private resetForm(): void {
    this.selectedFormEmployee = null;
    this.kpiManagerId = '';
    this.resetKpiRows();
  }

  // ── Tab 2: Report ───────────────────────────────────────────────────────────

  onReportSelectionChange(): void {
    this.showReport = false;
    this.reportData = [];
    this.incentiveDeduction = 0;
  }

  loadReport(): void {
    if (!this.selectedReportEmployee || !this.selectedReportMonth) {
      this.employeeService.showToast('error', 'Please select both employee and month');
      return;
    }

    this.loadingReport = true;
    this.showReport = false;
    this.reportData = [];

    const empId = this.selectedReportEmployee.employee_id;

    this.employeeService.getKpiReport(empId, this.selectedReportMonth).subscribe({
      next: (res: any) => {
        this.loadingReport = false;

        // Handle the API response format
        if (res.success && Array.isArray(res.data)) {
          console.log('Report data received:', res.data);
          this.buildReportRows(res.data);
          this.showReport = true;
        } else {
          this.showReport = true;
        }
      },
      error: (err: any) => {
        this.loadingReport = false;
        const msg = err?.error?.message || 'No report data found';
        this.employeeService.showToast('error', msg);
      }
    });
  }

  private buildReportRows(dataArray: any[]): void {
    if (!dataArray || dataArray.length === 0) {
      this.reportData = [];
      this.incentiveDeduction = 0;
      return;
    }

    const rows: ReportRow[] = [];

    // Map parameter names to row numbers
    const parameterToRowMap: { [key: string]: number } = {
      'Sales Target': 1,
      'Receipt Target': 2,
      'Brand Target (Shaji)': 3,
      'Brand Target (Zeal)': 4,
      'Brand Target (Cromax)': 5,
      'Active Qualified  > 70%': 6,
      'Active Qualified Target': 7,
      'Non Qualified to Qualified Target': 8,
      'Overdue Inactive': 9,
      'Total Overdue customer no': 10,
      'Active Leads': 11
    };

    dataArray.forEach(item => {
      const rowNo = parameterToRowMap[item.parameter];

      if (rowNo) {
        rows.push({
          no: rowNo,
          parameter: item.parameter,
          target: this.fmt(item.target),
          achieved: this.roundToTwoDecimals(item.current_month_value),
          managersScore: this.fmt(item.manager_score),
          score: this.fmt(item.score)
        });
      }
    });

    // Sort by row number
    rows.sort((a, b) => (a.no as number) - (b.no as number));

    this.reportData = rows;
    this.incentiveDeduction = 0;
  }

  private fmt(val: any): number | string {
    if (val === null || val === undefined) return '-';
    return val;
  }

  getSelectedMonthLabel(): string {
    if (!this.selectedReportMonth) return '';
    const [year, month] = this.selectedReportMonth.split('-');
    const date = new Date(Number(year), Number(month) - 1, 1);
    return date.toLocaleString('default', { month: 'long', year: 'numeric' });
  }

  // Add this method inside the KpiMonthlyReportsComponent class
  private roundToTwoDecimals(val: any): number | string {
    if (val === null || val === undefined) return '-';

    // If it's a number, round to 2 decimal places
    if (typeof val === 'number') {
      return Number(val.toFixed(2));
    }

    // If it's a string that can be converted to a number, round it
    if (typeof val === 'string' && !isNaN(Number(val))) {
      return Number(Number(val).toFixed(2));
    }

    return val;
  }

  getSelectedEmployeeName(): string {
    return this.selectedReportEmployee?.employee_name || '';
  }

  getScoreClass(score: number | string): string {
    if (score === '-' || score === null) return '';
    const n = Number(score);
    if (n >= 90) return 'score-excellent';
    if (n >= 75) return 'score-good';
    if (n >= 50) return 'score-average';
    return 'score-poor';
  }

  getManagerScoreClass(score: number | string): string {
    if (score === '-' || score === null) return '';
    const n = Number(score);
    if (n < 0) return 'manager-negative';
    if (n === 0) return 'manager-neutral';
    return 'manager-positive';
  }
}